import React from 'react';
import {Card, CardContent, Button, Typography, Box} from '@mui/material';
import useStyles from '../../../assets/styles/ProgramDashboardStyles';
import {PAYMENT_STATUS} from "../../../utils/constants";

/**
 * View: ProgramDashboard
 *
 * **Data Schema:**
 *
 * data = {
 *   steps: Array,                  // List of steps in the program (ProgramSteps component)
 *   steps[] = {
 *     id: number,                  // Unique identifier for each step
 *     icon: string,                 // Icon image for the step
 *     title: string,                // Title of the step
 *     content: string,              // Description or content for the step
 *     buttons: Array,               // List of buttons for the step (ProgramSteps component)
 *     buttons[] = {
 *       label: string,              // Button label
 *       url: string,                // URL for navigation (if applicable)
 *       onClick: function,           // Function to execute on button click (optional)
 *     },
 *     isDisabled: boolean           // Indicates whether the step is disabled
 *   }
 * }
 *
 * **Actions:**
 * - actions = {
 *  }
 *
 * **Options:**
 * options = {
 *  }
 */

const ProgramDashboardView = ({ data, options, actions }) => {
    const classes = useStyles();
    const { cardsData, programPaymentStatus } = data;
    const { activeStep } = options;
    const { navigationAction, upgradeToProAction } = actions;


    const handleNavigation = (url) => {
        navigationAction(url);
    };

    const handleUpgradeToPro = () => {
        upgradeToProAction();
    };

    return (
        <div className={classes.container}>
            <Typography variant="h4" className={classes.title}>
                Here’s your program!
            </Typography>
            <Box sx={{flexDirection:{xs:'column', sm:'row'}, padding: {xs:'0px',sm:'0px 110px'}, alignItems:{xs:'center',}, }} style={{ display: 'flex', justifyContent: 'space-around', }}>
                {cardsData.map((step, index) => (
                    <Card
                        key={index}
                        className={`${classes.card}`}
                        style={{ pointerEvents: index <= activeStep ? 'auto' : 'none' }}
                    >
                        <CardContent className={classes.cardContent}>
                            <div className={classes.cardHeader}>
                                {/*{(index === 2 || index === 3) && (*/}
                                {/*    <Button*/}
                                {/*        className={classes.upgradeButton}*/}
                                {/*        hidden={programPaymentStatus === PAYMENT_STATUS.SUCCESSFUL}*/}
                                {/*        onClick={handleUpgradeToPro}*/}
                                {/*    >*/}
                                {/*        Upgrade to Pro*/}
                                {/*    </Button>*/}
                                {/*)}*/}
                                <img src={step.icon} alt={step.title}
                                    style={{width: step.width, height: step.height, marginBottom: '20px', marginTop: '20px'}}/>
                                <Typography variant="h5"
                                            style={{color: '#fff', marginBottom: '10px'}}>{step.title}</Typography>
                            </div>
                            <Typography variant="body1" style={{
                                marginTop: '50px',
                                padding: '0 10px',
                                textAlign: 'center'
                            }}>{step.content}</Typography>
                            {index <= activeStep && (
                            <Box sx={{flexDirection:{sm:'row', xs:'column'}}} style={{display: 'flex', position: 'absolute', bottom: '25px', width:'95%',}}>
                                {step.buttons.map((button, btnIndex) => (
                                    <Button
                                        key={btnIndex}
                                        className={classes.button}
                                        variant="contained"
                                        onClick={() => {
                                            if (button.onClick) {
                                                button.onClick();
                                            } else if (button.url) {
                                                handleNavigation(button.url);
                                            }
                                        }}
                                        // disabled={!button.enabled}
                                    >
                                        {button.label}
                                    </Button>
                                ))}
                            </Box>
                            )}
                        </CardContent>
                    </Card>
                ))}
            </Box>
        </div>
    );
};

export default ProgramDashboardView;
